import styled from 'styled-components';
import { customMedia, defaultTransition } from 'styles/utils';
import { BlockSize } from 'libs/rendering/gltf/config';

import { Link } from 'core/routing';
import Button from 'components/Button';
import Icon from 'components/Icon';

export const HeaderStyled = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${BlockSize.height};
  background-color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1100;
`;

export const Crumbs = styled.ul`
  color: ${props => props.theme.color.wfGrey500};
  font-size: ${props => props.theme.font.size.small};
  padding: 0 ${props => props.theme.spacing.small};
  margin-right: auto;
  border-right: 1px solid ${props => props.theme.color.wfGrey500};
  height: ${BlockSize.height};
  line-height: ${BlockSize.height};
  strong {
    font-weight: ${props => props.theme.font.weight.regular};
    color: white;
  }
  ${Link} {
    color: ${props => props.theme.color.wfGrey500};
    &:hover {
      color: ${props => props.theme.color.wfWhite};
      text-decoration: underline;
    }
  }

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;

export const CrumbDivider = styled.span`
  padding: 0 0.125rem;
`;

export const NavStyled = styled.nav`
  padding: 0;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 0;
  right: 0;
`;

export const BurgerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${BlockSize.width};
  height: ${BlockSize.height};
  border-right: 1px solid ${props => props.theme.color.wfGrey500};
`;

export const DownloadIcon = styled.a`
  min-width: 200px;
`;

export const ButtonStyled = styled(Button)`
  height: ${BlockSize.height};
  color: white;
  padding: ${props => props.theme.spacing.default};
  align-items: center;
  border: none;
  border-${props =>
    `${props.borderRight ? 'right' : 'left'}: 1px solid ${
      props.theme.color.wfGrey500
    }`};
  background-color: ${props => props.theme.color.wfBlack};
  font-weight: ${props => props.theme.font.weight.xbold};
  border-radius: 0;

  ${props =>
    props.removeBorder &&
    `
    border: none;
  `}

  &:hover {
    color: ${props => props.theme.color.wfGrey500};
    background-color: ${props => props.theme.color.wfBlack};
    border-color: currentColor;
    text-decoration: none;
  }
  ${customMedia.lessThan('medium')`
    display: ${props => props.hideOnMobile && 'none'};
  `};
`;

export const DownloadButton = styled(ButtonStyled)`
  font-weight: ${props => props.theme.font.weight.regular};
  width: 100%;
  &:hover {
    border-color: ${props => props.theme.color.wfGrey500};
  }
`;

export const SignInUpButton = styled(ButtonStyled)`
  background-color: ${props => props.theme.color.wfBlue};
  &:hover {
    background-color: ${props => props.theme.color.wfBlue700};
    color: #fff;
  }
`;

export const CloseButton = styled(ButtonStyled)`
  color: ${props => props.theme.color.wfOrange};
  width: ${BlockSize.width};
  &:hover {
    border-color: ${props => props.theme.color.wfGrey500};
    color: ${props => props.theme.color.wfOrange700};
  }
`;

export const MakeButton = styled(ButtonStyled)`
  border: none;
  min-width: auto;
  padding: 0 1rem;
  background-color: ${props => props.theme.color.primary};
  ${defaultTransition('opacity')}

  svg {
    margin-left: 0.5rem;
  }

  &:hover {
    opacity: 0.8;
    color: ${props => props.theme.color.wfWhite};
    background-color: ${props => props.theme.color.primary};
  }
`;

export const DisabledMakeButton = styled(MakeButton)`
  background-color: ${props => props.theme.color.wfGrey900};
  color: ${props => props.theme.color.wfWhite};
  &:hover {
    opacity: 1;
    background-color: ${props => props.theme.color.wfGrey700};
  }
`;

export const DesktopWrapper = styled.div`
  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;

export const MainRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-right: auto;
`;

export const FreeSharesLeft = styled.small`
  color: #000;
  padding: 0.2rem 0.5rem;
  margin: 0 0.5rem;
  border-radius: 10px;
  /* line-height: 34px; */
  background-color: ${props =>
    props.leftCount === 0
      ? props.theme.color.wfGreen
      : props.theme.color.wfYellow};
  cursor: pointer;
`;

export const InfoIcon = styled(Icon)`
  margin-left: ${props => props.theme.spacing.small};
`;

export const DownloadEntryRow = styled.div`
  display: grid;
  grid-template-columns: 5fr 4fr 1fr;
  grid-column-gap:0.4em;
  height: ${BlockSize.height};
  color: white;
  padding: 0 10px;

  align-items: center;
  border: none;
  border-${props =>
    `${props.borderRight ? 'right' : 'left'}: 1px solid ${
      props.theme.color.wfGrey500
    }`};
  background-color: ${props => props.theme.color.wfBlack};
  font-weight: ${props => props.theme.font.weight.xbold};
  border-radius: 0;
  transform: translateY(-2px);
  cursor: pointer;

  ${props =>
    props.removeBorder &&
    `
    border: none;
  `}

  &:hover {
    color: ${props => props.theme.color.wfGrey500};
    background-color: ${props => props.theme.color.wfBlack};
    border-color: currentColor;
    text-decoration: none;
  }
  ${customMedia.lessThan('medium')`
    display: ${props => props.hideOnMobile && 'none'};
  `};
`;
